import Swal from "sweetalert2";
import { ValidateText } from "../../../Helpers/ValidateText";
import { GetKey } from "../../../Helpers/GetKey";

export const ClienteDatosGeneralesValidate = (state) => {
  if (state === undefined || state === null) {
    Swal.fire(
      "Clientes",
      "Error interno, favor de actualizar la aplicación si el problema persiste comuniquese con el administrador del sistema",
      "error"
    );
    return false;
  }

  if (
    !ValidateText(
      state.razonsocial,
      "Clientes",
      "El campo Razon Social es Obligatorio"
    )
  ) {
    return false;
  }

  if (!ValidateText(state.rfc, "Clientes", "El campo RFC es Obligatorio"))
    return;
  if (
    state.idvendedor === undefined ||
    state.idvendedor === null ||
    state.idvendedor === "" ||
    state.idvendedor === 0
  ) {
    Swal.fire(
      "Clientes",
      "Favor de seleccionar el asesor de venta relacionado con este cliente",
      "error"
    );
    return false;
  }

  if (state.rfc.length < 12 || state.rfc.length > 13) {
    Swal.fire(
      "Clientes",
      "El campo RFC debe contener de 12 a 13 caracteres",
      "warning"
    );
    return;
  }

  if (
    !ValidateText(
      state.regimenfiscal,
      "Clientes",
      "El campo Regimen Fiscal es Obligatorio"
    )
  )
    return false;

  if (
    !ValidateText(
      state.mediocontacto,
      "Clientes",
      "El campo Medio de Contacto es Obligatorio"
    )
  )
    return false;
  if (
    !ValidateText(
      state.tipopersona,
      "Clientes",
      "El campo Tipo Persona es Obligatorio"
    )
  )
    return false;
  if (state.tipopersona === "F - Fisica") {
    if (
      !ValidateText(state.nombre, "Clientes", "El campo Nombre es Obligatorio")
    )
      return false;
    if (
      !ValidateText(
        state.apellidopaterno,
        "Clientes",
        "El campo Apellido Paterno es Obligatorio"
      )
    ) {
      if (
        !ValidateText(
          state.apellidomaterno,
          "Clientes",
          "El campo Apellido Materno es Obligatorio"
        )
      )
        return false;
    }

    // if (!ValidateText(state.curp, "Clientes", "El campo CURP es Obligatorio"))
    //   return false;
    // if (state.curp.length !== 18) {
    //   Swal.fire(
    //     "Clientes",
    //     "El campo CURP debe contener de 18 caracteres",
    //     "warning"
    //   );
    //   return;
    // }
    if (!ValidateText(state.edad, "Clientes", "El campo Edad es Obligatorio"))
      return false;
    if (!ValidateText(state.sexo, "Clientes", "El campo Sexo es Obligatorio"))
      return false;
    if (
      !ValidateText(
        state.estadocivil,
        "Clientes",
        "El campo Estado Civil es Obligatorio"
      )
    )
      return false;
    if (state.estadocivil === "CA - Casado") {
      if (
        !ValidateText(
          state.regimenconyugal,
          "Clientes",
          "El campo Estado Civil es Obligatorio"
        )
      )
        return false;
    }
  } else {
    state.apellidopaterno = "";
    state.apellidomaterno = "";
    state.curp = "";
    state.nombre = "";
  }

  if (GetKey(state.tipo_persona === "M")) {
    return {
      idcliente: 0,
      rfc: state.rfc,
      razon_social: state.razonsocial,
      tipo_persona: GetKey(state.tipopersona),
      medio_contacto: GetKey(state.mediocontacto),
      regimen_fiscal: GetKey(state.regimenfiscal),
      idvendedor: GetKey(state.idvendedor),
    };
  } else {
    return {
      idcliente: 0,
      rfc: state.rfc,
      razon_social: state.razonsocial,
      tipo_persona: GetKey(state.tipopersona),
      medio_contacto: GetKey(state.mediocontacto),
      regimen_fiscal: GetKey(state.regimenfiscal),
      idvendedor: GetKey(state.idvendedor),
      nombre: state.nombre,
      nombre2:
        state.nombre2 === undefined ||
          state.nombre2 === null ||
          state.nombre2 === ""
          ? " "
          : state.nombre2,
      apellido_paterno: state.apellidopaterno,
      apellido_materno: state.apellidomaterno,
      curp: state.curp,
      sexo: GetKey(state.sexo),
      estado_civil: GetKey(state.estadocivil),
      regimen_conyugal:
        state.estadocivil === "CA - Casado"
          ? GetKey(state.regimenconyugal)
          : "NA",
      edad: state.edad,
    };
  }
};
